import React, { useState, useCallback, useEffect } from "react";
import { API } from "aws-amplify";
import Loader from "./Loader";
import Snackbar from "../../components/Snackbar";
import { messagefnSwitcher, messageSwitcher } from "../../utils/formHelper";
import { Link, Button } from "@material-ui/core";
import downloadImage from "../../images/icons8-download-100.png";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  container: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#fefefe",
    justifyContent: "center"
  },
  imgContainer: {
    width: 200,
    heigh: 200
  },
  linkContainer: {
    display: "flex",
    flexDirection: "column",
    textDecoration: "none"
  }
});
const DownloadView = ({ classes, survey, jwtToken }) => {
  const [loader, setLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [surveyToDownload, setSurveyToDownload] = useState({});
  const message = "fetching survey to download";
  const DEFAULT_LOCALE = "en";
  const DEFAULT_FILE_NAME = "survey.json";

  const renderMessage = (message, messageFunc, variant) => {
    if (!message) {
      return "";
    }
    return (
      <Snackbar
        message={message}
        onClose={() => messageFunc(null)}
        open={Boolean(message)}
        variant={variant}
      />
    );
  };
  const getSurvey = useCallback(async () => {
    setLoader(true);
    try {
      const response = await API.get(
        "surveys",
        `/surveys/${survey._id}/exporter/locale/${DEFAULT_LOCALE}`,
        {
          headers: { Authorization: `Bearer ${jwtToken}` }
        }
      );
      setSurveyToDownload(response);
      setSuccessMessage("survey to download retrieved");
      setLoader(false);
    } catch (error) {
      setLoader(false);
      setErrorMessage(error.message);
    }
  }, [survey, jwtToken]);

  useEffect(() => {
    getSurvey();
  }, [getSurvey]);

  return (
    <div className={classes.container}>
      <Loader loader={loader} message={message} />
      <Link
        className={classes.linkContainer}
        href={`data:text/json;charset=utf-8,${encodeURIComponent(
          JSON.stringify(surveyToDownload)
        )}`}
        download={DEFAULT_FILE_NAME}
      >
        <img
          className={classes.imgContainer}
          src={downloadImage}
          alt="download Icon"
        />
        <Button variant="contained" color="primary">
          Download
        </Button>
      </Link>
      {renderMessage(
        errorMessage || successMessage,
        messagefnSwitcher(
          errorMessage,
          successMessage,
          setErrorMessage,
          setSuccessMessage
        ),
        messageSwitcher(errorMessage)
      )}
    </div>
  );
};

export default withStyles(styles)(DownloadView);
